angular.module('impactx.classificationmaterialgroup').controller('ClassificationMaterialGroupListController', [
    'selectedListItems',
    ClassificationMaterialGroupListCtrl
]);

function ClassificationMaterialGroupListCtrl(selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ClassificationMaterialGroup'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/classificationmaterialgroup/templates/classificationmaterialgrouplist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/classificationmaterialgroup/list',
        ctrl: this,
        id: "classificationmaterialgrouplist",
        mainAction: {id: "new", link: "#/classificationmaterialgroup/0", icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "classificationmaterialgroup/" + selectedListItems.getFirstSelectedId();
    }
}